let $ = require("jquery");
import _ from "underscore";
import render from "../../../utilities/render";
import {setSwitchery,instantiateSwitchery} from '../../../utilities/instantiateSwitchery';
import AbilityStore from "../../../stores/AbilityStore";
import {setElementsFromScope, show, hide, setDisabledClass, setDisabled} from "../../../utilities/selectorHelpers";
import {createPreventDefault, isPresent} from '../../../utilities/general';
import {quickFileUploader} from "../../../components/QuickFileUploader/QuickFileUploader";
import CsvErrors from "./CsvErrors";
import AsnStore from "../../../stores/AsnStore";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import ProductItemStore from "../../../stores/ProductItemStore";
import SubmitModalFlow from "../../../components/SubmitModalFlow/SubmitModalFlow";

const modalHtml = require("../../../sharedHtml/modal.html");
const uploadPackingInfoModalBodyHtml = require('./html/uploadPackingInfoModalBody.html');
const packingDetailsInfoModalBodyHtml = require('./html/packingDetailsInfoModalBody.html');
const packingDetailsTemplateHtml = require('./html/subHtml/packingDetailsTemplate.html');
const packingDetailsListTemplateHtml = require('./html/subHtml/packingDetailsListTemplate.html');
const packingDetailsInfoModalProdList = require('./html/subHtml/packingDetailsInfoModalProdList.html');

const elementsMap = {
  uploadPackingDetailsBtn: ".upload-packing-details-btn",
  managePackingDetailsBtn: ".manage-packing-details-btn",
  downloadCsvBtn: '.download-template-btn',
  editOneBtn: ".asn-packing-details-container .edit-one-btn",
  removeOneBtn: ".asn-packing-details-container .remove-one-btn",
  removeAllBtn: ".remove-all-btn",
  removeOneConfirmOnModalBtn: ".remove-one-confirm-on-modal-btn",
  removeAllConfirmOnModalBtn: ".remove-all-confirm-on-modal-btn",
  asnPackingMethod: ".shipping-method-toggler",
  packingDetailsContainer: ".asn-packing-details-container",
  packingExpDate: ".packing-exp-date",
  packingDetailsInfoModalProdList: ".packing-details-info-modal-prod-list",
  packingMethod: '#asn-packing-method',
  uploadPackingDetailsSection: '.upload-csv-section',
  noPackingTypeSection: ".if-no-packing-type-chosen",
  parcelPrompt: ".if-case-packing-type-chosen",
  palletPrompt: ".if-pallet-packing-type-chosen",
  addNewCaseBtn: ".add-new-case-button",
  addNewPalletBtn: ".add-new-pallet-button",
  parcelCasesSection: ".parcel-cases-section",
  palletCasesSection: ".pallet-cases-section",
  savePackingInfoBtn: ".save-packing-info-btn",
  packingTypeName: ".packing-type-name",
  numberOfCasesOrPallets: ".number-of-cases-or-pallets",
  customCaseOrPalletIdsFlag: ".custom-case-or-pallet-ids-flag",
  customCaseOrPalletIdsList: ".custom-case-or-pallet-ids-list",
  //skuTypeAhead: ".sku-typeahead",
  beforeUserAddsProduct: ".before-user-adds-product",
  productRowNumber: ".product-row-number",
  asnDetailRowId: ".asn-detail-row-id",
  closeBtn: ".close-btn",
  unitsPerCase: ".units-per-case",
  warningCaseOrPalletIdsSizeSection: ".warning-case-ids-size-section",
  customCaseOrPalletIdsListSection: ".custom-case-or-pallet-ids-list-section",
  expDateInput: ".packing-exp-date",
  lotNumber: ".lot-number",
  caseOrPalletModalForm: ".case-or-pallet-modal-form",
  productItemLookup: "#product-item-lookup",
  printPackingSlipFlag: ".print-packing-slip-flag",
  duplicateLpnFlag : ".warning-lpn-dulicate-section",
  lengthLpnFlag: ".warning-lpn-length-section"
}

const elsFileModalMap = {
  loadingSpinner : '.loading-btn',
  uploadSuccessMessage : '.upload-success',
  uploadInvalidFileExtMessage : '.upload-file-ext-error',
  uploadOverwriteMessage : '.upload-overwrite-data',
  uploadIncorrectMessage : '.upload-incorrect-template',
  uploadFileError : '.upload-file-errors',
  uploadFileErrorListBtn : '.upload-file-errors-btn',
  uploadApplybtn : '.confirm-btn',
  uploadFileBtn : '.upload-file-btn',
  uploadFileInput : '.qfu-file-input',
  uploadFileTextInput: ".qfu-file-text-input",
  fileUploader: ".file-uploader",
  fileUploadForm: ".lpn-csv-upload-form"
}

export default function PackingTab(wizard){
  const self = this;
  const els = {};
  const wizardElement = wizard.getWizardElement();
  const packingTabElement = wizardElement.find('.packing-tab');
  const uploadCsvUrl = wizardElement.data("upload-csv-url");
  const errorListPageUrl = wizardElement.data("error-list-page-url");
  const asnValue = wizardElement.data("asn-id");
  const submitModal = new SubmitModalFlow();
  const productLookUpURL = wizardElement.data('product-lookup-url');
  const searchItemURL = wizardElement.data('search-item-url');
  const getItemsBySkusUrl = wizardElement.data('get-items-by-skus-url');
  const packingEntryPointElement = packingTabElement.find('.packing-tab-inner-entry-point');
  const validateLpnUrl = wizardElement.data("validate-lpn-url");

  let fileUploaderEl;
  let quickFileUploaderInstance;
  let csvErrors, errorData, validatedData;
  let fileValidator, caseOrPalletFormValidator;
  let editCaseOrPallet = false;

  const packingDetailsContainer = packingEntryPointElement.find(elementsMap.packingDetailsContainer);
  let packingDetailsInfoModalProdListContainer;
  let currentCaseOrPalletIds, currentViewingCaseOrPalletLineNumber;
  let currentProducts;
  //let skuTypeAhead = $();
  // modal definitions
  let removeOneModal, removeAllModal, uploadPackingDetailsModal, packingDetailsInfoModal;

  let upperCasePacking, lowerCasePacking;

  self.init = function(){
    // set default store information, if not available
    let shouldSelectPallet = !!getDefaultShippingMethod("pallet");
    if(shouldSelectPallet){
      upperCasePacking = "Pallet";
      lowerCasePacking = "pallet";
    }else{
      upperCasePacking = "Case";
      lowerCasePacking = "case";
    }

    attachWidgets();
    setElements();
    if(canEditGtlAsn()){
      bindElements();
    }
    bindStores();
    setValidator();

    //Trigger the shipping method change in store to generate all the tab views
    if(shouldSelectPallet){
      AsnStore.selectPallet();
    }
    else{
      AsnStore.selectParcel();
    }
    buildProductItemStore();
    assignDefualtPrintPackingSlip();
  };

  function assignDefualtPrintPackingSlip(){
    const asn = AsnStore.getAsnWithShippingMethod();
    if(asn.status == "New"){
     asn.printPackingSlipFlag=true;
    }else{
     instantiateSwitchery(els.printPackingSlipFlag, {});
     setSwitchery(els.printPackingSlipFlag, asn.printPackingSlipFlag);
    }
   }

  function getDefaultShippingMethod(shippingMethod){
    let asns = AsnStore.getAsns();
    return _.chain(asns).values().find((asn)=>{
      if(asn.status != "New"){ //edit
        return asn.shippingMethod === shippingMethod;
      }
    }).value();
  }

  self.isValid = function(){
    const asn = AsnStore.getAsnWithShippingMethod();
    return AsnStore.getAsnDetails(asn).length;
  }

  function buildProductItemStore(){
    var asnDetails = getAsnDetails();
    var skus = [];
    _(asnDetails).map((asnDetail, rowIdx)=>{
      skus.push(asnDetail.sku);
    });
    if(skus.length > 0){
      ProductItemStore.addSkusArrayToStore(skus, getItemsBySkusUrl);
    }
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, packingEntryPointElement);
    setElementsFromScope(els, elsFileModalMap, wizardElement);
  }

  function attachWidgets(){
    generateStaticModals();
    generateDynamicModals();
  }

  function bindElements(){
    instantiateSwitchery(els.printPackingSlipFlag);
    els.printPackingSlipFlag.on("change", onChangeofPrintPackingSlipFlag);
    els.uploadFileInput.on("change", handleFileInputChange);
    els.uploadFileBtn.on("click", createPreventDefault(handleUploadFileBtn));
    els.uploadApplybtn.on("click", createPreventDefault(handleApplyBtn));
    els.uploadFileErrorListBtn.on("click", createPreventDefault(handleViewErrorListBtn));

    els.uploadPackingDetailsBtn.click(createPreventDefault(showUploadPackingDetailModal));
    els.managePackingDetailsBtn.on('click', addNewPackingDetailsInfoModal);
    els.removeAllBtn.on('click', createPreventDefault(showRemoveAllModal));
    els.asnPackingMethod.change(createPreventDefault(setPackingTypes));

    // NOTE: these elements are targeted through the document on load because they're dynamically added to page after page load
    $(document).on("click", elementsMap.editOneBtn, showPackingDetailsInfoModal);
    $(document).on("click", elementsMap.removeOneBtn, showRemoveOneModal);
    $(document).on("click", elementsMap.removeOneConfirmOnModalBtn, createPreventDefault(removeOneCaseOrPallet));
    $(document).on("click", elementsMap.removeAllConfirmOnModalBtn, createPreventDefault(removeAllCaseOrPallet));
    $(document).on("click", elementsMap.savePackingInfoBtn, addOrUpdateCaseOrParcelHandler);
    $(document).on("click", elementsMap.closeBtn, onCloseBtnClick);
    $(document).on("change", elementsMap.unitsPerCase, onUnitsPerCaseInput);
    $(document).on("change", elementsMap.lotNumber, onLotNumberInput);
    $(document).on("change", elementsMap.expDateInput, onExpDateInput);
    $(document).on("change", elementsMap.customCaseOrPalletIdsFlag, showHideCustomCaseOrPalletIdsList);
  };

  function bindDynamicElements(){
    //skuTypeAhead.on('typeahead:selected', createNewAsnDetail);
  }

  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", handleShippingChangeRerender);
    AsnDetailStore.bindListener("asn_details:add", handleAddNewAsnDetail);
    AsnDetailStore.bindListener("asn_details:remove", handleRemoveAsnDetail);
    AsnDetailStore.bindListener("asn_details:change", updateSelf);
  }

  function handleShippingMethodActivation(value){
    hide(els.noPackingTypeSection);
    if(value === "parcel"){
      AsnStore.selectParcel();
    }else{
      AsnStore.selectPallet();
    }
  }

  function handleRemoveAsnDetail(){
    updateSelf();
  }

  function handleAddNewAsnDetail(){
    updateSelf();
  }

  function handleShippingChangeRerender(shippingMethod){
    updateSelf();
  }

  function updateSelf(){
    selectShippingMethod();
    toggleSubViews();
    getPackingDetails();
    handleDisabled();
  }

  function selectShippingMethod(){
    if(getAsnDetails().length > 0){
      if(isPallet()){
        els.asnPackingMethod.val(2); //Pallet
      }else{
        els.asnPackingMethod.val(1); //Case
      }

      els.uploadPackingDetailsSection.show();
    }

    if(els.asnPackingMethod.val() > 0){
      hide(els.noPackingTypeSection);
    }else{
      show(els.noPackingTypeSection);
    }
  }

  function toggleSubViews(){
    if(isParcel()){
      upperCasePacking = "Case";
      lowerCasePacking = "case";
      showParcelRelatedViews();
    }else if(isPallet()){
      upperCasePacking = "Pallet";
      lowerCasePacking = "pallet";
      showPalletRelatedViews();
    }
  }

  function showParcelRelatedViews(){
    els.palletPrompt.hide();
    els.palletCasesSection.hide();
    els.addNewPalletBtn.hide();
    if(getAsnDetails().length){
      // we need to hide the prompt,
      // they've already started adding
      // cases to the parcel section
      els.parcelPrompt.hide();
      els.parcelCasesSection.show();
      els.addNewCaseBtn.show();
      els.removeAllBtn.show();
    }
    else{
      els.parcelCasesSection.hide();
      if(els.asnPackingMethod.val() > 0){
        els.parcelPrompt.show();
      }
      els.addNewCaseBtn.hide();
      els.removeAllBtn.hide();
    }
  }


  function showPalletRelatedViews(){
    els.parcelPrompt.hide();
    els.parcelCasesSection.hide();
    els.addNewCaseBtn.hide();
    if(getAsnDetails().length){
      // we need to hide the prompt,
      // they've already started adding
      // cases to the pallet section
      els.palletPrompt.hide();
      els.palletCasesSection.show();
      els.addNewPalletBtn.show();
      els.removeAllBtn.show();
    }
    else{
      els.palletCasesSection.hide();
      if(els.asnPackingMethod.val() > 0){
        els.palletPrompt.show();
      }
      els.addNewPalletBtn.hide();
      els.removeAllBtn.hide();
    }
  }

  function handleDisabled(){
    if(!canEditGtlAsn()){
      setDisabled([
        els.asnPackingMethod
      ]);
      setDisabledClass([
        els.uploadPackingDetailsBtn,
        els.managePackingDetailsBtn,
        els.removeAllBtn
      ]);
      $(document).find(elementsMap.editOneBtn).attr('disabled','disabled');
      $(document).find(elementsMap.removeOneBtn).attr('disabled','disabled');
      $(document).find(elementsMap.lotNumber).attr('disabled','disabled');
      $(document).find(elementsMap.expDateInput).attr('disabled','disabled');
    }
  }

  function hasAnyMixedSkuCases(details){
    return AsnDetailStore.hasAnyMixedSkuCases(details);
  }

  function hasAnyMixedSkuCasesInAnyPallets(details){
    return AsnDetailStore.hasAnyMixedSkuCasesInAnyPallets(details);
  }

  function setPackingTypes(){
	  let sourceAsn = getAsn();
    if(els.asnPackingMethod.val() == 1){
      handleShippingMethodActivation('parcel');
    }else{
      handleShippingMethodActivation('pallet');
    }
	  let targetAsn = getAsn();
    targetAsn.isInternaltional = sourceAsn.isInternaltional;
    targetAsn.printPackingSlipFlag = sourceAsn.printPackingSlipFlag;
    targetAsn.printShippingLabelFlag = sourceAsn.printShippingLabelFlag;
    AsnStore.updateObjectAndEmit(targetAsn.id, targetAsn);

    generateDynamicModals();
    els.uploadPackingDetailsSection.show();
  }

  function addNewPackingDetailsInfoModal(e) {
    e.preventDefault();
    currentProducts = [];
    currentCaseOrPalletIds = [];
    let lineNumber = 1;
    if(isParcel()){
      lineNumber = AsnDetailStore.getNextCaseNumber();
    }else{
      lineNumber = AsnDetailStore.getNextPalletNumber();
    }
    //currentViewingCaseOrPalletLineNumber = lineNumber;
    if(isParcel()){
      packingDetailsInfoModal.find(elementsMap.packingTypeName).val("Case "+lineNumber);
    }else{
      packingDetailsInfoModal.find(elementsMap.packingTypeName).val("Pallet "+lineNumber);
    }
    packingDetailsInfoModal.find(elementsMap.numberOfCasesOrPallets).val('1');
    packingDetailsInfoModal.find(elementsMap.numberOfCasesOrPallets).val('1');
    //packingDetailsInfoModal.find(elementsMap.skuTypeAhead).val('');
    packingDetailsInfoModalProdListContainer.html('');
    const element = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsFlag);
    instantiateSwitchery(element, {});
    setSwitchery(element, false);
    packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsList).val('');
    packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).show();
    packingDetailsInfoModal.modal("show");
  }

  function showPackingDetailsInfoModal(e){
    editCaseOrPallet = true;
    e.preventDefault();
    packingDetailsInfoModal.find(elementsMap.warningCaseOrPalletIdsSizeSection).hide();
    packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).hide();
    packingDetailsInfoModal.find(elementsMap.lengthLpnFlag).hide();
 
    let caseOrPalletLineNumber = e.target.dataset.caseOrPalletLineNumber;
    currentViewingCaseOrPalletLineNumber = caseOrPalletLineNumber;
    currentCaseOrPalletIds = pickCaseOrPalletItems(caseOrPalletLineNumber);
    currentProducts = getProducts(currentCaseOrPalletIds).map(a => Object.assign({}, a));
    const product = getFirstProduct(currentCaseOrPalletIds);
    packingDetailsInfoModal.find(elementsMap.packingTypeName).val(product.packingTypeName);
    if(isParcel()){
      packingDetailsInfoModal.find(elementsMap.numberOfCasesOrPallets).val(product.numberOfCases);
    }else{
      packingDetailsInfoModal.find(elementsMap.numberOfCasesOrPallets).val(product.numberOfPallets);
    }
    const element = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsFlag);
    if(product.hasCustomIds){
      instantiateSwitchery(element, {});
      setSwitchery(element, true);
      packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsList).val(product.customCaseOrPalletIds);
    }else{
      instantiateSwitchery(element, {});
      setSwitchery(element, false);
      packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsList).val('');
    }
    showHideCustomCaseOrPalletIdsList();
    getPackageInfoModalProdList();
    if(currentProducts.length > 0){
      packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).hide();
    }else{
      packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).show();
    }
    packingDetailsInfoModal.modal("show");
  }

  function pickCaseOrPalletItems(caseOrPalletLineNumber){
    let viewCaseOrPalletIds = [];
    _(getCasesOrPallets()).map((asnDetail)=>{
      let ids = _(asnDetail).pluck("id");
      let lineNumber = 1;
      if(isParcel()){
        lineNumber = getFirstProduct(ids).caseLineNumber;
      }else{
        lineNumber = getFirstProduct(ids).palletLineNumber;
      }
      if(lineNumber == caseOrPalletLineNumber){
        viewCaseOrPalletIds = ids;
        return;
      }
    });
    return viewCaseOrPalletIds;
  }

  function getPackageInfoModalProdList(){
    packingDetailsInfoModalProdListContainer.html('');
    _(currentProducts).map((asnDetail, rowIdx)=>{
      const prodList = buildPackageInfoModalProdList(asnDetail, rowIdx);
      packingDetailsInfoModalProdListContainer.append(prodList);
    });
  }

  function buildPackageInfoModalProdList(asnDetail, rowIdx){
    const prodListItem = $(render(
      packingDetailsInfoModalProdList, {
        asnDetailRowNumber: rowIdx,
        skuName: asnDetail.sku,
        skuDesc: (getProductItem(asnDetail).prdDescription || "no description"),
        unitsPerCase: asnDetail.unitsPerCase
      }
    ));
    return prodListItem;
  }

  function onUnitsPerCaseInput(e){
    let asnDetail = currentProducts[$(e.target).closest(elementsMap.productRowNumber)[0].dataset.asnDetailRowNumber];
    asnDetail.unitsPerCase = $(e.target).val();
  }

  function onCloseBtnClick(e){
    e.preventDefault();
    let asnDetail = currentProducts[$(e.target).closest(elementsMap.productRowNumber)[0].dataset.asnDetailRowNumber];
    handleRemoveProductRows(asnDetail.id);
    getPackageInfoModalProdList();
    if(currentProducts.length > 0){
      packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).hide();
    }else{
      packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).show();
    }
  }

  function handleRemoveProductRows(id){
    currentProducts = currentProducts.filter(function(el){ return el.id != id; });
    //currentCaseOrPalletIds = currentCaseOrPalletIds.filter(function(el){ return el != id; });
  }

  function showHideCustomCaseOrPalletIdsList(){
    const customCaseOrPalletIdsFlagElement = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsFlag);
    const customCaseOrPalletIdsFlag = customCaseOrPalletIdsFlagElement.prop("checked");
    if(customCaseOrPalletIdsFlag){
      packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsListSection).show();
    }else{
      packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsListSection).hide();
      packingDetailsInfoModal.find(elementsMap.warningCaseOrPalletIdsSizeSection).hide();
      packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).hide();
      packingDetailsInfoModal.find(elementsMap.lengthLpnFlag).hide();
    }
  }

  function setCaseOrPalletModalValidator() {
    caseOrPalletFormValidator = packingDetailsInfoModal.find(elementsMap.caseOrPalletModalForm).validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      }
    });
    caseOrPalletFormValidator.settings.ignore = ":disabled,:hidden";
  }

  function addOrUpdateCaseOrParcelHandler(e){
    e.preventDefault();
    packingDetailsInfoModal.find(elementsMap.warningCaseOrPalletIdsSizeSection).hide();
    packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).hide();
    packingDetailsInfoModal.find(elementsMap.lengthLpnFlag).hide();
    if(!caseOrPalletFormValidator.elements().valid()){
      return;
    }
    //mulitple array of inputs like units-per-case
    const unitsElements = packingDetailsInfoModalProdListContainer.find(elementsMap.unitsPerCase);
    if(unitsElements.length > 0 && !unitsElements.valid()){
      return;
    }
    if(currentProducts.length <= 0){ //Need atleast one product
      return;
    }
    
    const numberOfCasesOrPallets = packingDetailsInfoModal.find(elementsMap.numberOfCasesOrPallets).val();
    const customCaseOrPalletIdsList = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsList).val();
    const packingTypeName = packingDetailsInfoModal.find(elementsMap.packingTypeName).val();
    const customCaseOrPalletIdsFlagElement = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsFlag);
    const customCaseOrPalletIdsFlag = customCaseOrPalletIdsFlagElement.prop("checked");

    if(customCaseOrPalletIdsFlag){
      const idslist = customCaseOrPalletIdsList.length > 0 ? customCaseOrPalletIdsList.split(",") : [];
      let uniqlist = _.uniq(idslist);
      let lengthError = false;
      if (uniqlist.length > 0) {
        _(uniqlist).map((lpnId)=> {
          if(lpnId.length > 0 && !(lpnId.length >= 16 && lpnId.length <= 20)){
            lengthError = true;
          }            
        });      
        if(lengthError == true){
          packingDetailsInfoModal.find(elementsMap.lengthLpnFlag).show();
          return;
        }
      }
      if(uniqlist.length != numberOfCasesOrPallets){
        packingDetailsInfoModal.find(elementsMap.warningCaseOrPalletIdsSizeSection).show();
        return;
      }else{
        packingDetailsInfoModal.find(elementsMap.warningCaseOrPalletIdsSizeSection).hide();
      }

      var asnDet = getAsnDetails();
      var caseOrPallets = AsnDetailStore.organizeIntoCases(asnDet);
      var savedcustomCaseOrPalletIdsList = [];

      if(_.isNull(asnValue) || _.isUndefined(asnValue) || asnValue === ""){  //LPN validation is not required for Edit Flow.
        let errt = validateLpn(); 
        if(errt == true){
          packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).show();
          return;
        }
      }

     }

    //Remove asn detail from store
    let asnDetailEdited = [];

    _(currentCaseOrPalletIds).map((currentCaseOrPalletId,id)=>{
      asnDetailEdited[id] = AsnDetailStore.getAsnDetail(currentCaseOrPalletId);
    });

     AsnDetailStore.removeAsnDetailsByIds(currentCaseOrPalletIds);
    //Add new asn detail to store
    let declaredValue = 0;
    let asnDetailId ;
    _(currentProducts).map((item)=>{
      if(isParcel()){
        item.numberOfCases = numberOfCasesOrPallets;
      }else{
        item.numberOfPallets = numberOfCasesOrPallets;
      }
      item.packingTypeName = packingTypeName;
      if(customCaseOrPalletIdsFlag){
        item.hasCustomIds = true;
        item.customCaseOrPalletIds = customCaseOrPalletIdsList;
      }else{
        item.hasCustomIds = false;
        item.customCaseOrPalletIds = "";
      }

      let productData = ProductItemStore.getDataViaAsnDetail(item);
      if(productData.length >0) {
        declaredValue += item.unitsPerCase * productData[0].itmCost;
      }

      if(AsnDetailStore.getAsnDetail(item.id)){
          handleAsnDetailChange(item.id, item);
      }else{
        asnDetailId = AsnDetailStore.createNewAsnDetail({asnId: getAsn().id, ...item});  
      }
    });


    if(customCaseOrPalletIdsFlag){
      var asnDet = getAsnDetails();
      let caseOrPallets;
      var savedcustomCaseOrPalletIdsList = [];

      if(isPallet()){
        caseOrPallets =  AsnDetailStore.organizeIntoPallets(asnDet);
      }else {
        caseOrPallets =  AsnDetailStore.organizeIntoCases(asnDet);
      }
//    savedcustomCaseOrPalletIdsList = customCaseOrPalletIdsList.length > 0 ? customCaseOrPalletIdsList.split(","):[];

      let isValid = true;
      _(caseOrPallets).each((asnDetailSubset, caseIdx)=>{
        const firstAsnDetail = asnDetailSubset[0];
        var caseIdList = firstAsnDetail.customCaseOrPalletIds.length > 0 ? firstAsnDetail.customCaseOrPalletIds.split(","):[];
        savedcustomCaseOrPalletIdsList = savedcustomCaseOrPalletIdsList.concat(caseIdList);
        let uniqlist = _.uniq(savedcustomCaseOrPalletIdsList);
        if(uniqlist.length < savedcustomCaseOrPalletIdsList.length){
            packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).show();
            isValid = false;
        }else{
          packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).hide();
        }
      });

      if(isValid == false && _.isEmpty(currentCaseOrPalletIds)){ //for new cases 
        AsnDetailStore.removeAsnDetailsByIds(pickCaseOrPalletItems(asnDetailId.caseLineNumber));
        return;
      }if(isValid == false && !_.isEmpty(currentCaseOrPalletIds) && !_.isEmpty(asnDetailEdited) ){
        _(asnDetailEdited).map((asnDetail,id)=>{
          AsnDetailStore.update(asnDetail.id, asnDetail);
        });
        return;
      }else if(isValid == false){
        return;
      }
   }

    if(declaredValue > 50000) {
      declaredValue = 50000;
    }

    _(currentProducts).map((item)=>{
      item.declaredValue = declaredValue;
      item.dvlCalculatedValue = declaredValue;
      handleAsnDetailChange(item.id, item);
    });
    packingDetailsInfoModal.modal("hide");
  }

  function showRemoveOneModal(e){
    let caseOrPalletLineNumber = e.target.dataset.caseOrPalletLineNumber;
    currentCaseOrPalletIds = pickCaseOrPalletItems(caseOrPalletLineNumber);
    removeOneModal.modal("show");
  }

  function removeOneCaseOrPallet(e){
    AsnDetailStore.removeAsnDetailsByIds(currentCaseOrPalletIds);
    removeOneModal.modal("hide");
  }

  function showRemoveAllModal(){
    removeAllModal.modal("show");
  }

  function removeAllCaseOrPallet(e){
    _(getCasesOrPallets()).map((asnDetail, rowIdx)=>{
      let ids = _(asnDetail).pluck("id");
      AsnDetailStore.removeAsnDetailsByIds(ids);
    });
    removeAllModal.modal("hide");
  }

  function getPackingDetails(){
    packingDetailsContainer.html('');
    _(getCasesOrPallets()).map((asnDetail, rowIdx)=>{
      rowIdx = rowIdx + 1;
      let ids = _(asnDetail).pluck("id");
      const packingDetail = buildPackingDetail(ids);
      packingDetailsContainer.append(packingDetail);
    });
    initPackingDetailExpDates();
  }

  function buildPackingDetail(ids){
    let numberOfCasesOrPallets = 1;
    let caseOrPalletLineNumber = 1;
    const asnDetail = getFirstProduct(ids);
    if(!asnDetail.packingTypeName){ // if name is not exist
      if(isParcel()){
        asnDetail.packingTypeName = "Case "+asnDetail.caseLineNumber;
      }else{
        asnDetail.packingTypeName = "Pallet "+asnDetail.palletLineNumber;
      }
    }

    let hasMixedSkus = false;
    if(isParcel()){
      numberOfCasesOrPallets = getFirstProductNumberOfCases(ids);
      caseOrPalletLineNumber = asnDetail.caseLineNumber;
      hasMixedSkus = hasAnyMixedSkuCases(ids);
    }else{
      numberOfCasesOrPallets = getFirstProductNumberOfPallets(ids);
      caseOrPalletLineNumber = asnDetail.palletLineNumber;
      hasMixedSkus = hasAnyMixedSkuCasesInAnyPallets(ids);
    }
    let customCaseOrPalletIds = "";
    if(asnDetail.hasCustomIds){
      customCaseOrPalletIds = asnDetail.customCaseOrPalletIds;
    }
    const packingDetailsEl = render(
      packingDetailsTemplateHtml, {
        packingTypeUpperCase: getPackingType(upperCasePacking),
        packingType: getPackingType(lowerCasePacking),
        packingTypeName: asnDetail.packingTypeName,
        numberOfCasesOrPallets: numberOfCasesOrPallets,
        packingProductsList: getPackingDetailProducts(ids),
        caseOrPalletLineNumber: caseOrPalletLineNumber,
        hasCustomIds: asnDetail.hasCustomIds,
        customCaseOrPalletIds: customCaseOrPalletIds,
        hasMultipleProducts: hasMixedSkus
      }
    );
    return packingDetailsEl;
  }

  function getPackingDetailProducts(ids){
    let html = "";
    _(getProducts(ids)).map((asnDetail, rowIdx)=>{
      rowIdx = rowIdx + 1;
      html = html.concat(buildPackingDetailList(asnDetail, rowIdx));
    });
    return html;
  }

  function buildPackingDetailList(asnDetail, rowIdx){
    let totalUnits = 1;
    if(isParcel()){
      totalUnits = asnDetail.unitsPerCase * asnDetail.numberOfCases;
    }else{
      totalUnits = asnDetail.unitsPerCase * asnDetail.numberOfPallets;
    }

    const listItem = render(
      packingDetailsListTemplateHtml, {
        uuid: _.uuid(),
        packingType: getPackingType(lowerCasePacking),
        asnDetailRowId: asnDetail.id,
        skuName: asnDetail.sku,
        skuDesc: (getProductItem(asnDetail).prdDescription || "no description"),
        unitsPerCase: asnDetail.unitsPerCase,
        totalUnits: totalUnits,
        packingExpDate: asnDetail.expirationDate,
        lotNumber: asnDetail.batchLotNumber,
        hasExpDateField: hasExpDate(asnDetail.sku),
        hasLotNumberField: hasLotNumber(asnDetail.sku)
      }
    );
    return listItem;
  }

  function onExpDateInput(e){
    const target = $( e.target );
    const asnDetail = getAsnDetail(target.data("asn-detail-row-id"));
    const val = target.val();
    if(target.val() === asnDetail.expirationDate){
      return;
    }
    handleAsnDetailChange(asnDetail.id, {expirationDate: val});
  }

  function onLotNumberInput(e){
    const target = $( e.target );
    const asnDetail = getAsnDetail(target.data("asn-detail-row-id"));
    const val = target.val();
    handleAsnDetailChange(asnDetail.id, {batchLotNumber: val});
  }

  function createNewAsnDetail(sku){
    //const sku = skuTypeAhead.typeahead('val');
    if(sku.length == 0)
      return;
    let newAsnDetail = {};
    if(currentCaseOrPalletIds.length){
      newAsnDetail = handleAddProduct();
      if(isParcel()){
        newAsnDetail.caseLineNumber = currentViewingCaseOrPalletLineNumber;
      }else{
        newAsnDetail.palletLineNumber = currentViewingCaseOrPalletLineNumber;
      }
    }else{
      if(isParcel()){
        newAsnDetail = AsnDetailStore.createNewCaseSkeletonIncrementedAsnDetail({asnId: getAsn().id});
      }else{
        newAsnDetail = AsnDetailStore.createNewPalletSkeletonIncrementedAsnDetail({asnId: getAsn().id});
      }
    }
    newAsnDetail.sku = sku;
    currentProducts.push(newAsnDetail);
    //currentCaseOrPalletIds.push(newAsnDetail.id);
    packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).hide();
    getPackageInfoModalProdList();
    //skuTypeAhead.typeahead('val', '');
  }

  function handleAddProduct(){
    const attrs = _(getFirstProduct(currentCaseOrPalletIds)).pick(
      "caseLineNumber",
      "palletLineNumber",
      "numberOfCases",
      "numberOfPallets",
      "asd_package_length",
      "asd_package_width",
      "asd_package_height",
      "asd_package_weight",
      "stackablePallet",
      "declaredValueInput",
      "useCalculatedVal",
      "dvlInsideCase"
    );
    return AsnDetailStore.createSkeletonAsnDetail(attrs);
    //return AsnDetailStore.createNewAsnDetail({asnId: getAsn().id, ...attrs});
  }

  function instantiateSkuTypeAhead(){
    /*skuTypeAhead = packingDetailsInfoModal.find(elementsMap.skuTypeAhead).typeahead({
      highlight: true
    },
    {
      name: 'sku',
      source: typeAheadSource(
        ProductItemStore.getSkus()
      )
    });*/

    const select2AjaxDefaults = {
      dataType: 'json',
      delay: 250,
      async:false,
      processResults: function (data, params) {
        params.page = params.page || 1;
        return {
          results: data,
          pagination: {
            more: (params.page * 20) < data.total_count
          }
          };
      },
      cache: true
    };

    function configureDataCallback({paramKey}){
      return function(params){
        return {
          [paramKey] : params.term
        };
      };
    }

    const productItemLookup = packingDetailsInfoModal.find(elementsMap.productItemLookup);
    productItemLookup.select2({
      placeholder: "Type product name (SKU)",
      dropdownParent: packingDetailsInfoModal,
      allowClear: true,
      ajax: {
        ...select2AjaxDefaults,
        url:productLookUpURL,
        data: configureDataCallback({paramKey: '_asn_WAR_hcportlet_likeSku'})
      },
      minimumInputLength: 3
    });

    productItemLookup.on("select2:select", function(e) {
      lookupFromStore(this.value);
      productItemLookup.val(null).trigger('change');
    });

  }

  function lookupFromStore(itemSku){
    if(itemSku == "") {
        return;
    }
    if(ProductItemStore.doesSkuExist(itemSku)){
      createNewAsnDetail(itemSku);
    }else{
      var createNewAsnDetailFlag = true;
      ProductItemStore.addSkuToStore(itemSku, searchItemURL);
      createNewAsnDetail(itemSku);
    }
  }

  function handleAsnDetailChange(id, newData){
    AsnDetailStore.update(id, newData);
  }

  function initPackingDetailExpDates(){
    const date = new Date();
    packingEntryPointElement.find(elementsMap.packingExpDate).datepicker({
      startDate: date,
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });
    packingEntryPointElement.find(elementsMap.packingExpDate).keypress(function(event) {event.preventDefault();}); //make non-typeable/readonly texbox
  }

  // here we are updating the range allowed
  // for the expiration date,
  // as well as the default value if necessary
  function updateExpDateRange(){
    const input = els.expDateInput;

    if(!hasProductItemForSku()){
      return;
    }
    const shelfLife = parseInt(getProductItemForSku().shelfLife || 0, 10);

    if(!shelfLife){
      return;
    }

    const date = new Date();
    date.setDate(date.getDate() + shelfLife);

    input.datepicker("setStartDate", date);

    const asnDetail = getAsnDetail();
    if(typeaheadSelectAttempted){
      typeaheadSelectAttempted = false;
      input.datepicker("update", date);
    }
  }

  function hasLotNumber(sku){
    return doesProductForSkuRequireLotNumber(sku);
  }

  function hasExpDate(sku){
    return isProductForSkuPerishable(sku);
  }

  function doesProductForSkuRequireLotNumber(sku){
    const productItem = getProductItemForSku(sku);
    return productItem && ProductItemStore.doesRequireLotNumber(productItem);
  }

  function isProductForSkuPerishable(sku){
    const productItem = getProductItemForSku(sku);
    return productItem && ProductItemStore.isPerishable(productItem);
  }

  function hasProductItemForSku(sku){
    return !!getProductItemForSku(sku);
  }

  function getProductItemForSku(sku){
    return ProductItemStore.findWhere({itmSku: sku});
  }

  function getPackingType(packingType){
    return packingType;
  }

  function generateStaticModals(){
    uploadPackingDetailsModal = $(render(
      modalHtml,
      {
        title: 'Upload Packing Information',
        leftAlignTitle: true,
        body: render(uploadPackingInfoModalBodyHtml),
        topCloseBtn: true,
        autoHideTop: true,
        modalDialogClass: "q-modal-dialog-800",
        footerBtns: `
          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" class="base-btn purple-btn confirm-btn">Apply</a>
        `
      }
    ));

    wizardElement.append(uploadPackingDetailsModal);
    fileUploaderEl = uploadPackingDetailsModal.find(elsFileModalMap.fileUploader);
    quickFileUploaderInstance = quickFileUploader(fileUploaderEl);
  }

  function getPackingDetailsInfoModal(){
    packingDetailsInfoModal = $(render(
      modalHtml,
      {
        title: `${getPackingType(upperCasePacking)} Information`,
        leftAlignTitle: true,
        modalDialogClass: "q-modal-dialog-800",
        body: render(packingDetailsInfoModalBodyHtml, {
          packingTypeUpperCase: getPackingType(upperCasePacking),
          packingType: getPackingType(lowerCasePacking)
        }),
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" class="base-btn purple-btn save-packing-info-btn">Save ${getPackingType(upperCasePacking)}</a>
        `
      }
    ));
    return packingDetailsInfoModal;
  }

  function getPackingDetailsInfoModalProdList(){
    packingDetailsInfoModal = $(render(
      modalHtml,
      {
        title: `${getPackingType(upperCasePacking)} Information`,
        leftAlignTitle: true,
        modalDialogClass: "q-modal-dialog-800",
        body: render(packingDetailsInfoModalBodyHtml, {
          packingTypeUpperCase: getPackingType(upperCasePacking),
          packingType: getPackingType(lowerCasePacking)
        }),
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" class="base-btn purple-btn save-packing-info-btn">Save ${getPackingType(upperCasePacking)}</a>
        `
      }
    ));
    return packingDetailsInfoModal;
  }

  function getRemoveOneModal(){
    removeOneModal = $(render(
      modalHtml,
      {
        title: `Remove ${getPackingType(upperCasePacking)}`,
        leftAlignTitle: true,
        modalDialogClass: "q-modal-dialog-500",
        body: `<div class='q-marg-all-xl'>Are you sure you want to remove this ${getPackingType(lowerCasePacking)}?</div>`,
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" class="base-btn purple-btn remove-one-confirm-on-modal-btn">Remove ${getPackingType(upperCasePacking)}</a>
        `
      }
    ));
    return removeOneModal;
  }

  function getRemoveAllModal(){
    removeAllModal = $(render(
      modalHtml,
      {
        title: `Remove All ${getPackingType(upperCasePacking)}s`,
        leftAlignTitle: true,
        modalDialogClass: "q-modal-dialog-500",
        body: `<div class='q-marg-all-xl'>Are you sure you want to remove all ${getPackingType(lowerCasePacking)}s?</div>`,
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" class="base-btn purple-btn remove-all-confirm-on-modal-btn">Remove ${getPackingType(upperCasePacking)}s</a>
        `
      }
    ));
    return removeAllModal;
  }

  function generateDynamicModals(){
    // NOTE: to make btn dynamic with text variable for case vs. pallet, put btns in separate html file and render
    if(packingDetailsInfoModal){
      packingDetailsInfoModal.remove('.modal');
    }
    if(removeOneModal){
      removeOneModal.remove('.modal');
    }
    if(removeAllModal){
      removeAllModal.remove('.modal');
    }

    wizardElement.append(getPackingDetailsInfoModal(), getRemoveOneModal(), getRemoveAllModal());
    instantiateSkuTypeAhead();
    bindDynamicElements();
    setCaseOrPalletModalValidator();
    packingDetailsInfoModalProdListContainer = wizardElement.find(elementsMap.packingDetailsInfoModalProdList);
  }

  function showUploadPackingDetailModal(){
    hideAllUploadMessages();
    uploadPackingDetailsModal.modal("show");
    els.uploadApplybtn.attr('disabled', true);
    els.uploadFileBtn.attr('disabled', false);
    els.uploadFileInput.val("");
    els.uploadFileTextInput.val("");
    if(isAsnDetailsPresent()) {
      els.uploadOverwriteMessage.show();
    }
  }

  function handleViewErrorListBtn() {
    csvErrors = new CsvErrors(wizardElement, errorData);
    csvErrors.init();
    let w = window.open(errorListPageUrl);

    $(w).on('load', function(){
      $(w.document.body).find(".error-list").html(csvErrors.getErrorHtml());
    });
  }

  function setValidator() {
      fileValidator = els.fileUploadForm.validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      }
    });

    fileValidator.settings.ignore = ":disabled,:hidden";
  }

  function onChangeofPrintPackingSlipFlag(){
    const asn = AsnStore.getAsnWithShippingMethod();
    asn.printPackingSlipFlag=els.printPackingSlipFlag.is(":checked");
  }

  function handleFileInputChange(event) {
      hideAllUploadMessages();

      var fileName = quickFileUploaderInstance.getFile().name.split(".");
      var ext =  fileName[1].toLowerCase();
      if(ext != "csv") {
        els.uploadInvalidFileExtMessage.show();
        els.uploadFileInput.val();
        els.uploadApplybtn.attr('disabled', true);
        els.uploadFileBtn.attr('disabled', true);
      } else {
        els.uploadInvalidFileExtMessage.hide();
        els.uploadApplybtn.attr('disabled', true);
        els.uploadFileBtn.show();
        els.uploadFileBtn.attr('disabled', false);
      }
  }

  function handleApplyBtn() {
     
      if(!isElementDisabled(els.uploadApplybtn)) {
        uploadPackingDetailsModal.modal("hide");
        
        AsnDetailStore.storeFromUploadJson(validatedData);
        buildProductItemStore();
        AsnDetailStore.emitEvent('add');
      }
  }

  function handleUploadFileBtn(e) {
     let formData = new FormData();
     let asnId;
     // if Upload file button is disabled due to incorrect file extension, then dont do anything
     if(isElementDisabled(els.uploadFileBtn)) {
      return;
     }

     if(fileValidator.elements().valid()) {
       formData.append('packingMethod', els.packingMethod.val());
       formData.append('csvFile', els.uploadFileInput[0].files[0]);

       if(els.packingMethod.val() == "1") {
          asnId = AsnStore.getAsnWithShippingMethod("parcel").id;
       } else {
          asnId = AsnStore.getAsnWithShippingMethod("pallet").id;
       }
       formData.append('asnStoreId', asnId);
       //alert(uploadCsvUrl);
        $.ajax({
          url: uploadCsvUrl,
          type: "POST",
          enctype:"multipart/form-data",
          processData:false,
          contentType:false,
          dataType: "json",
          data:  formData,
          beforeSend: function () {
            hideAllUploadMessages();
            els.uploadFileBtn.hide();
            els.loadingSpinner.show();
          },
          complete: function () {
            els.loadingSpinner.hide();
          },
          success: function (data, textStatus, jqXHR) {
            if(data.result == 'success') {
              els.uploadSuccessMessage.show();
              els.uploadFileBtn.show();
              els.uploadApplybtn.attr('disabled', false);
              els.uploadFileBtn.attr('disabled', false);
              validatedData = data.dataList;
            } else if(data.result == 'validationErrors') {
              els.uploadApplybtn.attr('disabled', true);
              els.uploadFileBtn.hide();
              els.uploadFileBtn.attr('disabled', false);
              els.uploadFileError.show();
              els.uploadFileErrorListBtn.show();
              errorData = data.errorList;
            } else {
              els.uploadFileBtn.attr('disabled', false);
              els.uploadApplybtn.attr('disabled', true);
              els.uploadIncorrectMessage.show();
            }
          },
          error: function(){
            els.uploadFileBtn.attr('disabled', false);
            els.uploadApplybtn.attr('disabled', true);
            els.uploadIncorrectMessage.show();
          }
        });
     }
  }

  function isAsnDetailsPresent(){
    return _.size(AsnDetailStore.asnDetailsAsArray()) > 0;
  }

  function isElementDisabled(element) {
    return $(element).is('[disabled=disabled]');
  }

  function hideAllUploadMessages() {
    hide(els.uploadSuccessMessage);
    hide(els.uploadInvalidFileExtMessage);
    hide(els.uploadOverwriteMessage);
    hide(els.uploadIncorrectMessage);
    hide(els.uploadFileError);
    hide(els.uploadFileErrorListBtn);
  }

  function getCasesOrPallets(){
    if(isPallet())
      return AsnDetailStore.organizeIntoPallets(getAsnDetails());
    else if(isParcel())
      return AsnDetailStore.organizeIntoCases(getAsnDetails());
  }

  function getAsnDetails(){
    return AsnStore.getAsnDetails(getAsn());
  }

  function getAsnDetail(id){
    return AsnDetailStore.getAsnDetail(id);
  }

  function getAsn(){
    if(isPallet())
      return AsnStore.getOrCreateAsnWithShippingMethod("pallet");
    else
      return AsnStore.getOrCreateAsnWithShippingMethod("parcel");
  }

  function getProducts(ids){
    return AsnDetailStore.getAsnDetails(ids);
  }

  function getShippingMethod(){
    return AsnStore.getShippingMethod();
  }

  function isParcel(){
    return getShippingMethod() === 'parcel';
  }

  function isPallet(){
    return getShippingMethod() === 'pallet';
  }

  function canEditGtlAsn(){
    return AbilityStore.ask("canEditGtlAsn");
  }

  function getFirstProductNumberOfCases(ids){
    return parseInt(getFirstProduct(ids).numberOfCases, 10) || 1;
  }

  function getFirstProductNumberOfPallets(ids){
    return parseInt(getFirstProduct(ids).numberOfPallets, 10) || 1;
  }

  function getFirstProduct(ids){
    return getProducts(ids)[0];
  }

  function getProductItem(asnDetail){
    return ProductItemStore.getDataViaAsnDetail(asnDetail)[0] || {};
  }

  const hasAsnDetailsWithoutPallets = AsnDetailStore.hasAsnDetailsWithoutPallets;
  const hasAsnDetailsWithoutCases = AsnDetailStore.hasAsnDetailsWithoutCases;

  function validateLpn() {
    const customCaseOrPalletIds = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsList).val();
    let result = "";
    $.ajax({
        async: false,
        data: {
          [`${portletNamespace}customCaseOrPalletIds`]:customCaseOrPalletIds
        },
        url: validateLpnUrl,
        dataType:"JSON",
        type: 'POST',
        success: function(data){          
          result = data.response;
        }  
     });
     
     return result;
  }


}



// WEBPACK FOOTER //
// ./src/pages/asns/PackingTab/PackingTab.js